import { Pipe, inject } from '@angular/core';
import { RouterBaseService } from '../services/router/router-base.service';
import { LinkRegistryService } from '../services/link-registry.service';
import type { PipeTransform } from '@angular/core';

/**
 * @description  Intended to be used with translate directive to pass url as a translation param
 * .maps linkId & optional params to LinkRegistryService.getLink
 *
 * @linkId {string} Id of link in link table
 *
 * @returns {string} url for corresponding linkId or UI.Router state
 *
 * @example
 *
 * Basic Example:
 * <a href="{{ 'link_id' | tdWbHref }}">Link  Text</a>
 *
 * Example with parameters for tdWbHref
 * <a href="{{ 'link_id' | tdWbHref: { name: 'mama'} }}">Link Text</a>
 *
 */
@Pipe({
  name: 'tdWbHref'
})
export class HrefPipe implements PipeTransform {
  private readonly linkRegistryService = inject<LinkRegistryService>(LinkRegistryService);
  private readonly routerService = inject<RouterBaseService>(RouterBaseService);

  transform(value: string | undefined, params?: Record<string, unknown | Array<unknown>>): string {
    let newHref = this.linkRegistryService.getLink(value, params, true);

    if (newHref === undefined) {
      // fallback to ui-router state if linkId not found in config
      newHref = this.routerService.getStateUrl(value, params);
      if (newHref === undefined || newHref === null) {
        newHref = this.linkRegistryService.getLink(value, params);
      }
    }

    return newHref;
  }

}
